export default "__VITE_ASSET__CmdzfJKt__"